// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { ActiveStatus } from './active-status';
import { DocSubmitType } from './doc-submit-type';
import { Kit } from './kit';
import { Supplier } from './supplier';
import { SupplierAdmin } from './supplier-admin';
import { SupplierInventoryApproval } from './supplier-inventory-approval';
import { SupplierSubmissionStatus } from './supplier-submission-status';
import { ActiveStatusEnum } from './enums';
import { DocSubmitTypeEnum } from './enums';
import { SupplierSubmissionStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import { EntityPropertyAnnotation, EntityTypeAnnotation } from '../entity-type-annotations';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SupplierAccount extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static getEntityTypeAnnotation(): EntityTypeAnnotation {
    const propAnnotations = [
      // invoiceEmail accepts one OR multiple emails separated by spaces, commas, or
      // semicolons. The shared BaseEntity.multipleEmailValidator splits on /[ ,;]/ and
      // validates each piece individually.
      new EntityPropertyAnnotation('invoiceEmail', {
        validators: [BaseEntity.multipleEmailValidator],
      }),
    ];

    return new EntityTypeAnnotation({
      validators: [],
      propertyAnnotations: propAnnotations,
    });
  }

  getStatusParents() {
    return [this.account, this.supplier];
  }

  getStatusId() {
    return this.activeStatusId;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId!: string;
  /** String(20) */
  accountTaxExemptionNumber?: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Boolean */
  allowInventory!: boolean;
  /** Boolean */
  allowPartialShipments!: boolean;
  /** Guid FK assignedSupplierAdmin */
  assignedSupplierAdminId?: string;
  /** Boolean */
  chargeAddonsOnReissuance!: boolean;
  /** Int32 */
  dueDateNumDays?: number;
  /** Enum FK invoiceDocSubmitType */
  invoiceDocSubmitTypeId!: DocSubmitTypeEnum;
  /** String(100) */
  invoiceEmail?: string;
  /** Int32 */
  leadTimeToShipNumDays!: number;
  /** Binary */
  rowVersion!: any;
  /** Boolean */
  saveOutputToPdf!: boolean;
  /** Guid FK supplier */
  supplierId!: string;
  /** Enum FK supplierSubmissionStatus */
  supplierSubmissionStatusId!: SupplierSubmissionStatusEnum;
  /** FK accountId */
  account!: Account;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK assignedSupplierAdminId */
  assignedSupplierAdmin!: SupplierAdmin;
  /** FK invoiceDocSubmitTypeId */
  invoiceDocSubmitType!: DocSubmitType;
  /** Inv FK supplierAccountId */
  kits!: Kit[];
  /** FK supplierId */
  supplier!: Supplier;
  /** Inv FK supplierAccountId */
  supplierInventoryApprovals!: SupplierInventoryApproval[];
  /** FK supplierSubmissionStatusId */
  supplierSubmissionStatus!: SupplierSubmissionStatus;
}

